import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  title: string;
  desc?: string;
  crumbs: Crumb[];
}

export default function PageHeader({ title, desc, crumbs }: PageHeaderProps) {
  return (
    <div className="bg-background-50 border-b border-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-6 md:py-8">
        <Breadcrumb items={crumbs} />
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
          {title}
        </h1>
        {desc && (
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-3xl leading-relaxed">
            {desc}
          </p>
        )}
      </div>
    </div>
  );
}